import quickFetch from 'quick-fetch';
import http from 'hub-http/clients/apiClient';
export const quickFetchHelper = (earlyRequestName, url) => {
  const earlyRequest = quickFetch.getRequestStateByName(earlyRequestName);
  if (earlyRequest) {
    return new Promise(resolve => {
      earlyRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest(url);
      });
      earlyRequest.onError(() => {
        resolve(http.get(url));
        quickFetch.removeEarlyRequest(url);
      });
    });
  }
  return http.get(url);
};